// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fcnm","col":"styles_col__39OEK"};